import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // Import the translation hook
import './App.css';

const Footer = () => {
  const { t } = useTranslation();  // Get the translation function

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-nodes">
          <a href="https://bitcoin.si/" target="_blank" rel="noopener noreferrer">
            <img className="footer-node-img" src={`${process.env.PUBLIC_URL}/Bitcoin_drustvo_Slovenije.png`} alt="Bitcoin društvo Slovenije" />
          </a>
          <a href="https://europeanbitcoiners.com/" target="_blank" rel="noopener noreferrer">
            <img className="footer-node-img" src={`${process.env.PUBLIC_URL}/EU_Bitcoiners.png`} alt="European Bitcoiners" />
          </a>
        </div>
        <p><s><em>{t('never_sell_bitcoin')}</em></s></p>
        <p><em>{t('never_sell_bitcoin_for_fiat')}</em></p>
        <p>&copy; {new Date().getFullYear()} bitcoincene.si - <Link to="https://primal.net/dejan">Dejan</Link></p>
        <nav>
          <ul className="footer-links">
            <li><Link to="/politika-zasebnosti">{t('privacy_policy')}</Link></li>
            <li><Link to="/politika-piskotkov">{t('cookie_policy')}</Link></li>
            <li><Link to="/pogoji-uporabe">{t('terms_of_use')}</Link></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;

